import {
  createContext,
  createRef,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react'

import { CollectionContextState } from './types'

const productContainerRef = createRef<HTMLDivElement>()

const CollectionContext = createContext<CollectionContextState>({
  productContainerRef,
})

export const Collection = ({ children }: PropsWithChildren): JSX.Element => {
  const context = useMemo(
    () => ({ productContainerRef }),
    [productContainerRef],
  )

  return (
    <CollectionContext.Provider value={context}>
      {children}
    </CollectionContext.Provider>
  )
}

export const useCollectionContext = () => useContext(CollectionContext)
